import { LucideIcon } from "lucide-react";
import { Card } from "./card";

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  iconColor: string;
  bgColor: string;
}

export const FeatureCard = ({
  icon: Icon,
  title,
  description,
  iconColor,
  bgColor
}: FeatureCardProps) => {
  return (
    <Card className="p-6 hover:shadow-lg transition-all duration-300 group">
      <div className="flex flex-col items-center text-center space-y-3">
        <div className={`p-3 rounded-full ${bgColor} group-hover:scale-110 transition-transform`}>
          <Icon className={`h-6 w-6 ${iconColor}`} />
        </div>
        <h3 className="font-semibold">{title}</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </Card>
  );
};